import clsx from 'clsx';
import React from 'react';

interface UserSeatsProps {
  className: string;
  count: number;
  text: string;
}

const UserSeats = ({ className, count, text }: UserSeatsProps) => {
  return (
    <p className="m-0 font-suisse-intl text-form text-black">
      <span className={clsx('mr-16 inline-block h-10 w-10 rounded-full', className)} />
      {text} user seats: {count}
    </p>
  );
};

export default UserSeats;
